import { AxiosError } from "axios";
import { CommonResponseModel } from "../Models/tableDetailsModel";
import { ApiRequestError } from "./apiRequestError";

export const DEFAULT_API_ERROR_MESSAGE = "Something went wrong. Please try again later.";

type CommonResponseErrorBody = Pick<CommonResponseModel<unknown>, "flagStatus" | "error">;

const isNonEmptyString = (value: unknown): value is string =>
    typeof value === "string" && value.trim().length > 0;

type ParsedCommonResponseError = {
    flagStatus: false;
    error: string;
};

const isCommonResponseErrorBody = (data: unknown): data is ParsedCommonResponseError => {
    if (!data || typeof data !== "object") return false;

    const body = data as CommonResponseErrorBody;
    return body.flagStatus === false && isNonEmptyString(body.error);
};

const getAxiosResponseErrorMessage = (error: AxiosError): string | null => {
    const data = error.response?.data;
    if (isCommonResponseErrorBody(data)) {
        return data.error.trim();
    }
    return null;
};

export const getApiErrorMessage = (
    error: unknown,
    fallback: string = DEFAULT_API_ERROR_MESSAGE
): string => {
    if (error instanceof ApiRequestError) {
        return error.displayMessage;
    }

    if (error instanceof AxiosError) {
        const responseMessage = getAxiosResponseErrorMessage(error);
        if (responseMessage) {
            return responseMessage;
        }
        return fallback;
    }

    if (error instanceof Error && isNonEmptyString(error.message)) {
        return error.message.trim();
    }

    return fallback;
};
